import { z } from 'zod';

// POST /broker/uploads/presigned-url
// Returns a presigned S3 PUT URL the browser can use to upload an image
// directly to S3 (no proxy through the API). On completion, the publicUrl
// can be persisted into a property photo list or broker page content.
export const presignedUploadRequest = z
  .object({
    /** Logical category · drives the object key prefix in S3. */
    purpose: z.enum(['property_photo', 'broker_avatar', 'broker_cover']),
    contentType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
    /** Original filename (sanitized server-side, used for the extension). */
    filename: z.string().min(1).max(200),
  })
  .strict();

export type PresignedUploadRequest = z.infer<typeof presignedUploadRequest>;

export const presignedUploadResponse = z
  .object({
    /** PUT this URL directly from the browser with the file as body. */
    uploadUrl: z.string().url(),
    /** Final public URL of the object once the upload succeeds. */
    publicUrl: z.string().url(),
    /** Expiry in seconds; client should not cache beyond this. */
    expiresIn: z.number().int().positive(),
  })
  .strict();

export type PresignedUploadResponse = z.infer<typeof presignedUploadResponse>;
